"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const paginator_styles_1 = __importDefault(require("./paginator.styles"));
const b = b_1.default.with('paginator');
const COUNT = 3;
const WIDTH = 3;
function Paginator() {
    const { current = 0, length = 0 } = (0, react_redux_1.useSelector)((state) => {
        const { length } = state.pages.list;
        const current = state.pages.currentPage;
        return { current, length };
    });
    function getOffset() {
        const middle = Math.ceil(COUNT / 2);
        const curr = current + 1;
        // Если все влазит, то ничего не двигаем
        if (length <= COUNT) {
            return 0;
        }
        // Если это первые 2, то ничего не двигаем
        if (middle > curr) {
            return 0;
        }
        // Если это последние 2, то двигаем на предпоследний
        if (length - curr < middle) {
            return length - COUNT;
        }
        return curr - middle;
    }
    const pages = [];
    let i = 0;
    while (i < length) {
        pages.push(i++);
    }
    const offsetIndex = getOffset();
    const style = { transform: `translateX(-${offsetIndex * WIDTH}em)` };
    const containerStyle = { maxWidth: `${COUNT * WIDTH - WIDTH / 2}em` };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: paginator_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('container'), style: containerStyle }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('pages'), style: style }, { children: pages.map(pageNumber => {
                        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('page', {
                                active: pageNumber <= current ? 'yes' : 'no'
                            }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('page-circle') }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: b('page-text') }, { children: pageNumber + 1 })) })) }), `p${pageNumber}`));
                    }) })) }))] })));
}
exports.default = Paginator;
